export const CLERK_CAPTCHA_APPEARANCE = {
  theme: "dark",
  size: "flexible",
} as const;

export const CLERK_CAPTCHA_ELEMENT_CLASSNAME =
  "!mt-1 !mb-2 !flex !w-full !max-w-full !justify-center !overflow-visible";

export function isClerkCaptchaPath(
  pathname: string | null | undefined,
): boolean {
  if (!pathname) {
    return false;
  }

  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

  return (
    normalized === "/sign-in" ||
    normalized.startsWith("/sign-in/") ||
    normalized === "/sign-up" ||
    normalized.startsWith("/sign-up/")
  );
}
